import { EtabProfileModel, IEtabProfile } from "@core/models";

export class EtabProfileDTO extends EtabProfileModel {
  prepareUpdateAdditionalInfoData() {
    return {
      couverts: this[IEtabProfile.seats],
      presentation: this[IEtabProfile.description],
    };
  }

  prepareUpdateData() {
    return {
      couverts: this[IEtabProfile.seats],
      facebook: this[IEtabProfile.facebook],
      presentation: this[IEtabProfile.description],
      web: this[IEtabProfile.website],
    };
  }
}
